import { createFileRoute } from "@tanstack/react-router"
import { StripeRefreshPage } from "@/pages"

export const Route = createFileRoute(
  "/_authenticated/_organization/organization-settings/billing/stripe-refresh"
)({
  component: StripeRefreshPage,
})
